import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { FormNewgalleriesComponent } from '@components/form-newgalleries/form-newgalleries.component'
import { FooterNewgalleriesComponent } from '@components/footer-newgalleries/footer-newgalleries.component'
import { HeaderNewgalleriesComponent } from '@components/header-newgalleries/header-newgalleries.component'
import { Gallery } from '../../interfaces/api/Gallery'
import { NgIf } from '@angular/common'
import { ApiService } from '../../services/api.service'
import { GalleryStatus } from '../../interfaces/api/GalleryStatus'
import { LoadingComponent } from '@components/loading/loading.component'
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component'
import { TranslateModule, TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-newgalleries',
  templateUrl: './newgalleries.component.html',
  styleUrl: './newgalleries.component.scss',
  standalone: true,
  imports: [FormNewgalleriesComponent, FooterNewgalleriesComponent, HeaderNewgalleriesComponent, NgIf, LoadingComponent, ConfirmModalComponent, TranslateModule]
})
export class NewgalleriesComponent implements AfterViewInit, OnInit {
  formValid: boolean = false;
  creating: boolean = true;
  gallery: Gallery;
  galleryId: string | null = null;
  @ViewChild(FormNewgalleriesComponent) formComponent!: FormNewgalleriesComponent;
  isConfirmModalVisible: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, private api: ApiService, private translate: TranslateService) {}

    private translations() {
        this.translate.get([
            'gallery-application.COUNTERTOP',
            'gallery-application.CURTAIN_WALL_FACADE',
            'gallery-application.FACADE',
            'gallery-application.FIREPLACE',
            'gallery-application.FLOORING',
            'gallery-application.FURNITURE',
            'gallery-application.INTERIOR_CLADDING',
            'gallery-application.OUTSIDE_COUNTERTOP',
            'gallery-application.STAIR',
            'gallery-application.STICK_BUILD_FACADE',
            'gallery-application.SWIMMING_POOL',
            'gallery-application.VENTILATED_FACADE',
            'gallery-category.BATHROOM',
            'gallery-category.KITCHEN',
            'gallery-category.LIVING',
            'gallery-category.OTHER',
            'gallery-category.OUTSIDE',
            'gallery-space.HEALTH_AND_WELLNESS',
            'gallery-space.HOTEL',
            'gallery-space.OFFICE',
            'gallery-space.PUBLIC_SPACE',
            'gallery-space.RESIDENTIAL',
            'gallery-space.RESTAURANT',
            'gallery-space.RETAIL',
            'gallery-style.CLASSIC',
            'gallery-style.CONTEMPORARY',
            'gallery-style.INDUSTRIAL',
            'gallery-style.MEDITERRANEAN',
            'gallery-style.MINIMALIST',
            'gallery-style.MODERN',
            'gallery-style.NORDIC',
            'gallery-style.RUSTIC',
            'gallery-style.VINTAGE',
            'status-gallery.APPROVED',
            'status-gallery.DRAFT',
            'status-gallery.PENDING_APPROVAL',
            'status-gallery.REJECTED'
        ])
    }
  ngOnInit(): void {
      console.log('NewgalleriesComponent.ngOnInit()');

    this.route.queryParams.subscribe(params => {
      this.galleryId = params['id'];

      if (this.galleryId) {
          this.creating = false;
        this.loadGalleryData(this.galleryId);
      } else {
          this.gallery = {
              category: null,
              description: null,
              images: [],
              name: null,
              space: null,
              status: GalleryStatus.DRAFT,
              style: null
          };
      }
    });
  }

  ngAfterViewInit() {
    if (!this.formComponent) {
      console.error('formComponent no está disponible');
    }
  }

  onFormStatusChange(valid: boolean) {
    this.formValid = valid;
  }

  onPublish() {
    if (!this.formComponent) {
      console.warn('Formulario aún no está disponible');
      return;
    }

    const newGallery = this.formComponent.getFormData();
    
    if (newGallery) {
      newGallery.status = GalleryStatus.PENDING_APPROVAL;
      this.api.myGalleries__create(newGallery)
        .subscribe((gallery) => {
          this.gallery = gallery
          this.isConfirmModalVisible = true;
        });
    }
  }

  goBack(): void {
    this.router.navigate(['/my-galleries']);
  }

  private loadGalleryData(galleryId: string): void {
    this.api.myGalleries__view(galleryId)
        .subscribe((gallery) => this.gallery = gallery);
  }

}
